module.exports = __webpack_public_path__ + "static/old-street-f08b2114bf19f18f77f116652ec4e578.svg";